import { injectToolCSS } from "../utils/cssGenerator";

export const hideImagesConfig = {
    id: 'hide-images',
    enable: false,
    css: `
        img, picture, video {
            visibility: hidden !important;
            opacity: 0 !important;
        }
        [style*="background-image"] {
            background-image: none !important;
        }
    `
};

export default function hideImages(enable = false) {
    injectToolCSS({
        ...hideImagesConfig,
        enable
    });
}